/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { SupplierListItemFragmentDoc } from '../../features/suppliers/SupplierListItem.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SuppliersQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit: Types.Scalars['Int']['input'];
  sorting?: Types.InputMaybe<Array<Types.PimSearchSuppliersSorting>>;
  filterSearchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SuppliersQuery = { suppliers: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimSearchSuppliersResult', totalCount: number, suppliers: Array<{ __typename: 'PimSupplier', id: string, title: string, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }> } };


export const SuppliersDocument = gql`
    query Suppliers($offset: Int, $limit: Int!, $sorting: [PimSearchSuppliersSorting!], $filterSearchTerm: String) {
  suppliers: pimSearchSuppliers(
    offset: $offset
    limit: $limit
    sorting: $sorting
    search: $filterSearchTerm
    filters: {isSubscribed: true}
  ) {
    ... on PimSearchSuppliersResult {
      suppliers {
        id
        ...SupplierListItem
      }
      totalCount
    }
  }
}
    ${SupplierListItemFragmentDoc}`;

/**
 * __useSuppliersQuery__
 *
 * To run a query within a React component, call `useSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppliersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sorting: // value for 'sorting'
 *      filterSearchTerm: // value for 'filterSearchTerm'
 *   },
 * });
 */
export function useSuppliersQuery(baseOptions: Apollo.QueryHookOptions<SuppliersQuery, SuppliersQueryVariables> & ({ variables: SuppliersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuppliersQuery, SuppliersQueryVariables>(SuppliersDocument, options);
      }
export function useSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuppliersQuery, SuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuppliersQuery, SuppliersQueryVariables>(SuppliersDocument, options);
        }
export function useSuppliersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuppliersQuery, SuppliersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuppliersQuery, SuppliersQueryVariables>(SuppliersDocument, options);
        }
export type SuppliersQueryHookResult = ReturnType<typeof useSuppliersQuery>;
export type SuppliersLazyQueryHookResult = ReturnType<typeof useSuppliersLazyQuery>;
export type SuppliersSuspenseQueryHookResult = ReturnType<typeof useSuppliersSuspenseQuery>;
export type SuppliersQueryResult = Apollo.QueryResult<SuppliersQuery, SuppliersQueryVariables>;